<form #zipcodeForm="ngForm" class="row">
	<mat-form-field class="col">
		<mat-label>{{ label }}</mat-label>
		<input matInput aria-label="Zipcode" type="text" [placeholder]="placeholder" [id]="id" [name]="name"
			[matAutocomplete]="auto" [(ngModel)]="selectedZipcode.POSTAL_CODE" #searchString="ngModel"
			#searchStringInput [value]="selectedZipcode?.POSTAL_CODE" [required]="required"
			(ngModelChange)="checkForId(searchString)" [disabled]="disabled" />
		<button mat-icon-button matSuffix [attr.aria-label]="'Zipcode Valid'"
			[color]="selectedZipcode && selectedZipcode.ID ? 'primary' : 'warn'" tabindex="-1" [disabled]="disabled">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && (zipcodeForm.dirty || selectedZipcode?.ID! > 0)">
				{{ selectedZipcode.ID ? "done" : "close" }}
			</mat-icon>
		</button>
	</mat-form-field>
	<app-msg *ngIf="!isLoading" class="msg-position"
		[msg]="{MSG:searchString.errors?.['idRequired'], SUCCESS:!searchString.errors?.['idRequired']}"></app-msg>
	<app-msg *ngIf="displayRequiredMessage && !isLoading && !searchString.errors?.['idRequired']" class="msg-position"
		[msg]="requiredMsg"></app-msg>		

	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
		<ng-container *ngIf="!isLoading">
			<mat-option *ngFor="let zipcode of zipcodes" [value]="zipcode">
				{{zipcode.POSTAL_CODE}}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
</form>
